<template>
  <div class="wrapper">
    <div class="wrapper-header">
      <span>
        <a-icon type="project" class="margin-right-small" />
        MANIFEST CREDIT CARD RECONCILE
        <div>{{ initialData.no_rekon }}</div>
      </span>
      <div>
        <!-- <a-tag v-if="mode.type=='draft'" color="orange">DRAFT</a-tag> -->
      </div>
    </div>
    <div class="wrapper-body">
      <div class="container-essential margin-large">
        <a-form :form="forms">
          <a-row :gutter="12">
            <a-col :xs="{ span: 24 }" :lg="{ span: 12 }" class="m-page-wrapper">
              <a-form-item label="Period">
                  <a-select
                  placeholder="Select Period ... "
                  v-decorator="['period', { rules: [{ required: true, message: 'please choose the date!' }], initialValue: initialData.period }]"
                  :disabled="mode.type!='create'"
                  class="width-full"
                  showSearch
                  allowClear
                >
                  <a-select-option
                    v-for="item in optionBase.periode"
                    :key="item"
                    :value="item"
                    >{{ item }}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="Billing Statement Number">
                <a-input v-decorator="['billing_statement', { rules: [{ required: true }], initialValue: initialData.billing_statement }]"
                :disabled="mode.type!='create'"
                >
                </a-input>
              </a-form-item>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 12 }" class="m-page-wrapper">
              <a-form-item label="Credit Card Users">
                <a-select
                  placeholder="Select Credit Card User ... "
                  v-decorator="['credit_card_user', { rules: [{ required: true }], initialValue: initialData.credit_card_user }]"
                  class="width-full"
                  showSearch
                  allowClear
                  optionFilterProp="children"
                  :filterOption="filterOption"
                  :disabled="mode.type!='create'"
                >
                  <a-select-option
                    v-for="item in optionBase.kartu_kredit"
                    :key="item.id_user_cc"
                    :value="item.id_user_cc"
                    >{{ item.tlc_user }}/{{ item.no_cc }}/{{ item.type_cc }}/{{ item.jenis }}</a-select-option
                  >
                </a-select>
              </a-form-item>
              <a-form-item label="Description">
                <a-input v-decorator="['description', { rules: [{ required: true }], initialValue: initialData.description }]"
                :disabled="mode.type!='create'"
                >
                </a-input>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
        <div class="m-display-flex space-end margin-top">
          <!-- <a-button type="primary" icon="hourglass" @click="handleGenerate" :loading="loading.generate" :disabled="mode.type!='create'">Generate</a-button> -->
        </div>
      </div>
      <a-table
        :rowKey="(record, index) => {return index;}"
        :columns="table.column"
        :dataSource="baseData"
        :pagination="table.pagination"
        :loading="table.loading"
        size="small"
        class="tablereconciledtl margin-large"
        bordered
        :scroll="{ x: 950 }"
        :rowClassName="(record) => {return !record.check ? 'bg_red' : 'bg_none' }"
      >
        <div slot="title">
          <a-row :gutter="32">
            <a-col :xs="{ span: 24 }" :lg="{ span: 16 }" class="m-page-wrapper">
              <div class="wrapper-header-child">
                <span>
                  Reconcile Detail
                </span>
              </div>
              <div class="margin-top">
                <div class="m-display-flex flex-col" style="align-content: center;">
                  <!-- <b style="align-content: center;">Filter by Color :&nbsp;&nbsp;&nbsp;</b>
                  <a-checkbox v-model="table.filterBG.putih" @change="onChangeWhiteCheck" class="m-display-flex flex-col" style="align-content: center;top:2px">
                    <div style="width:50px; background-color: white;border: 1px solid #d9d9d9;">&nbsp;</div>
                  </a-checkbox>
                  <a-checkbox v-model="table.filterBG.merah" @change="onChangeWhiteCheck" class="m-display-flex flex-col" style="align-content: center;top:2px">
                    <div style="width:50px; background-color: rgba(231, 76, 60, 0.35);border: 1px solid #d9d9d9;">&nbsp;</div>
                  </a-checkbox> -->
                  <a-input-search v-model="table.search" placeholder="Quick Search" />
                </div>
              </div>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 8 }" class="m-page-wrapper">
              <div class="margin-top-small m-display-flex space-between m-text-bold">
                <span>Total Nominal : </span>
                <span>{{ formatCurrency('IDR', table.datasource.total) }}</span>
              </div>
              <div class="margin-top-small m-display-flex space-between m-text-bold">
                <span>Total Reconcile : </span>
                <span>{{ formatCurrency('IDR', table.datasource.has_recon) }}</span>
              </div>
              <div class="margin-top-small m-display-flex space-between m-text-bold">
                <span>Total Not yet Reconcile : </span>
                <span>{{ formatCurrency('IDR', table.datasource.yet_recon) }}</span>
              </div>
            </a-col>
          </a-row>
        </div>
        <span slot="no" slot-scope="text, item, index">
          {{index+(table.pagination.page>1 ? ((table.pagination.page-1)*table.pagination.pageSize)+1 : 1)}}
        </span>
        <span slot="action" slot-scope="data">
          <a-checkbox @change="changeChecked(data)" :checked="data.check"/>
        </span>
        <span slot="tgl_transaksi" slot-scope="item">
          {{moment(item.tgl_transaksi).format(getDefaultDateFormat)}}
        </span>
        <span slot="nominal" slot-scope="item">
          <CurrencyJustified
            :currencyValue="'IDR'"
            :valueNumber="item.nominal_rekon"
          />
        </span>
        <div slot="footer">
          <a-row :gutter="12">
            <a-col :xs="{ span: 24 }" :lg="{ span: 16 }" class="m-page-wrapper">
              <!-- <div><b><small>Color Desc:</small></b></div>
                <div style="display:flex;vertical-align: middle;margin-top:5px"><div class="bg_red" style="width:20px;height: 100%;">&nbsp;</div><small>&nbsp;Not Yet Reconcile</small></div> -->
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 8 }" class="m-page-wrapper">
              <a-form-item label="Upload Billing Statement">
                <a-upload
                    :fileList="evidance_billing_statement.fileList"
                    v-model="evidance_billing_statement.files"
                    :remove="handleRemove"
                    :beforeUpload="beforeUpload"
                    :showUploadList="{showRemoveIcon:false}"
                    class="onlyviewlnk"
                >
                    <a-button hidden>
                    <a-icon type="upload" />Select File
                    </a-button>
                </a-upload>
            </a-form-item>
            </a-col>
          </a-row>
        </div>
      </a-table>
      <!-- <div class="padding-all m-display-flex flex-row space-end">
        <a-button-group>
          <a-button
            type="default"
            icon="save"
            :disabled="table.datasource.file==null && evidance_billing_statement.fileList.length==0"
            @click="handleSubmit('draft')"
          >Draft</a-button>
          <a-button
            type="primary"
            icon="save"
            :disabled="table.datasource.file==null && evidance_billing_statement.fileList.length==0"
            @click="handleSubmit('final')"
          >Submit</a-button>
        </a-button-group>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import _ from "lodash";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import GlobalMethod from "@/mixins/GlobalMethod.js";
export default {
  name: "CC_Manifest_Reconcile",
  mixins: [CurrencyFormat, GlobalMethod],
  props:['type','id'],
  data(){
    return {
      loading: {
        generate: false
      },
      mode: {
        id: null,
        type: null
      },
      table: {
        column: [
          {
            title: "No",
            key: "no",
            width: "50px",
            scopedSlots: { customRender: "no" },
          },
          // {
          //   title: "Action",
          //   key: "action",
          //   width: "75px",
          //   scopedSlots: { customRender: "action" },
          // },
          {
            title: "CC Transaction Number",
            key: "cc_transaction_number",
            width: "200px",
            dataIndex: "user_cc"
          },
          {
            title: "Transaction Date",
            key: "tgl_transaksi",
            width: "150px",
            align: "center",
            scopedSlots: { customRender: "tgl_transaksi" },
          },
          {
            title: "Item Detail",
            key: "item_detail",
            dataIndex: "item_transaksi"
          },
          {
            title: "Nominal",
            key: "nominal",
            width: "175px",
            scopedSlots: { customRender: "nominal" },
          }
        ],
        datasource:{
          id_rekon_cc_hdr: "",
          hdr: [],
          dtl: [],
          total: 0,
          has_recon: 0,
          yet_recon: 0,
          file: null,
        },
        pagination: {
          current: 1,
          page: 1,
          onChange: (page) => {
            this.table.pagination.page = page;
            this.table.pagination.current = page;
          },
          pageSize: 5,
          size: "small",
        },
        filterBG:{
          putih: true,
          merah: true,
        },
        loading: false,
        search: null
      },
      evidance_billing_statement:{
        fileList: [],
        files: []
      },
      optionBase: {
        kartu_kredit: [],
        periode: []
      },
    }
  },
  beforeCreate() {
    this.forms = this.$form.createForm(this);
  },
  mounted(){
    if(this.type && this.id){
      this.mode.type = this.type
      this.mode.id = this.id
      this.fetchEdit()
    }else if(this.type==undefined){
      this.mode.type = 'create'
      this.mode.id = null
    }
    this.getOptionBase();
  },
  computed:{
    ...mapGetters(["getAuth", "getScreen","getDefaultDateFormat","getStandartFormatDate"]),
    initialData(){
      return this.type=='create' ? {
        period: undefined,
        billing_statement: undefined, 
        credit_card_user: undefined,
        description: undefined,
        no_rekon: undefined
      } : {
        no_rekon: this.table.datasource.hdr.no_rekon,
        period: this.table.datasource.hdr.periode,
        billing_statement: this.table.datasource.hdr.no_billing, 
        credit_card_user: this.table.datasource.hdr.user_cc,
        description: this.table.datasource.hdr.deskripsi
      }
    },
    baseData(){
      return this.table.datasource.dtl.filter((item)=>{
        return (this.table.filterBG.putih && this.table.filterBG.merah ? true :
               !this.table.filterBG.putih && !this.table.filterBG.merah ? false :
               ((this.table.filterBG.putih ? item.check : false) || (this.table.filterBG.merah ? !item.check : false) )) &&
              (this.table.search ? 
                ( item.item_transaksi && item.item_transaksi.toLowerCase().indexOf(this.table.search.toLowerCase()) >=0 ||
                  item.tgl_transaksi && moment(item.tgl_transaksi).format('DD-MM-YYYY').indexOf(this.table.search.toLowerCase()) >=0 ||
                  item.user_cc && item.user_cc.indexOf(this.table.search.toLowerCase()) >=0
                )
               : true)
      })
    }
  },
  methods:{
    moment,
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].elm.textContent
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    onChangeWhiteCheck(){
      this.table.pagination.current = 1;
      this.table.pagination.page = 1;
    },
    filterWarna(val){
      if(val){ 
        this.dataSource.dtl = this.dataSource.dtlOri.filter(item => item.tlc.toLowerCase().indexOf(val.toLowerCase()) >=0 )
      }else{
        this.dataSource.dtl = this.dataSource.dtlOri
      }

      if(this.filterBG.putih){
        this.dataSource.dtl = this.dataSource.dtl.filter(
          item => item.absensi==item.absensi_sebelum &&
                  item.admin_bank==item.admin_bank_sebelum && 
                  item.cop_perusahaan==item.cop_perusahaan_sebelum &&
                  item.cop_karyawan==item.cop_karyawan_sebelum &&
                  item.hutang_karyawan==item.hutang_karyawan_sebelum &&
                  item.inactive==item.inactive_sebelum &&
                  item.jht_karyawan==item.jht_karyawan_sebelum &&
                  item.jht_perusahaan==item.jht_perusahaan_sebelum &&
                  item.jkk_perusahaan==item.jkk_perusahaan_sebelum &&
                  item.jkm_perusahaan==item.jkm_perusahaan_sebelum &&
                  item.jp_karyawan==item.jp_karyawan_sebelum &&
                  item.jp_perusahaan==item.jp_perusahaan_sebelum &&
                  item.kesehatan_karyawan==item.kesehatan_karyawan_sebelum &&
                  item.kesehatan_perusahaan==item.kesehatan_perusahaan_sebelum &&
                  item.kesehatan_tambahan==item.kesehatan_tambahan_sebelum &&
                  item.makan==item.makan_sebelum &&
                  item.mobil==item.mobil_sebelum &&
                  item.pimpro==item.pimpro_sebelum &&
                  item.potongan_koperasi==item.potongan_koperasi_sebelum
        )
      }

      if(this.filterBG.merah){
        this.dataSource.dtl = this.dataSource.dtl.filter(
          item => item.absensi!=item.absensi_sebelum ||
                  item.admin_bank!=item.admin_bank_sebelum || 
                  item.cop_perusahaan!=item.cop_perusahaan_sebelum ||
                  item.cop_karyawan!=item.cop_karyawan_sebelum ||
                  item.hutang_karyawan!=item.hutang_karyawan_sebelum ||
                  item.inactive!=item.inactive_sebelum ||
                  item.jht_karyawan!=item.jht_karyawan_sebelum ||
                  item.jht_perusahaan!=item.jht_perusahaan_sebelum ||
                  item.jkk_perusahaan!=item.jkk_perusahaan_sebelum ||
                  item.jkm_perusahaan!=item.jkm_perusahaan_sebelum ||
                  item.jp_karyawan!=item.jp_karyawan_sebelum ||
                  item.jp_perusahaan!=item.jp_perusahaan_sebelum ||
                  item.kesehatan_karyawan!=item.kesehatan_karyawan_sebelum ||
                  item.kesehatan_perusahaan!=item.kesehatan_perusahaan_sebelum ||
                  item.kesehatan_tambahan!=item.kesehatan_tambahan_sebelum ||
                  item.makan!=item.makan_sebelum ||
                  item.mobil!=item.mobil_sebelum ||
                  item.pimpro!=item.pimpro_sebelum ||
                  item.potongan_koperasi!=item.potongan_koperasi_sebelum
        )
      }
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      }

      let data = new FormData();
      data.append("id_rekon_cc_hdr", this.mode.id);
      data.append("file_support", file);

      this.table.loading = true
      this.asyncAxiosPost("kartu_kredit/recon_upload", "formdata", this.getAuth, data)
      .then(() => {
        // this.table.datasource = response
        // this.table.datasource.dtl.forEach((element,index) => {
        //   element['no'] = index
        //   element['check'] = element.sts_rekon=='1' ? true : false
        // });
        // this.setUpFile(response.file_path, response.file_nm, response.file);
        this.fetchEdit()

        this.displayMessageValue("success-other", 'Upload file has been success!');
        this.table.loading = false
      })
      .catch((err) => {
        let responses = Object.assign({}, err);
        if (responses.data) {
          this.displayMessageValue("error-other", responses.data.message);
        } else {
          this.displayMessageValue("error", responses.response);
        }
        this.evidance_billing_statement.fileList = [];
        this.table.loading = false

      });
      return false;
    },
    handleRemove() {
        this.evidance_billing_statement.fileList = [];
    },
    getOptionBase(){
      this.asyncAxiosGet("kartu_kredit/recon_select",
        this.getAuth,
        {}
      )
      .then((res) => {
        this.optionBase = res
      })
    },
    handleGenerate(){
      this.forms.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        let data = new FormData();
        data.append("period", values.period);
        data.append("no_billing_statement", values.billing_statement);
        data.append("user_kartu_kredit", values.credit_card_user);
        data.append("description", values.description);

        this.loading.generate = true
        this.asyncAxiosPost("kartu_kredit/recon_generate", "formdata", this.getAuth, data)
        .then((response) => {
          this.table.datasource = response
          this.loading.generate = false
        })
        .catch((err) => {
          this.loading.generate = false
          let response = Object.assign({}, err.response);
          if (response.data.status == false && response.data.message) {
            this.displayMessageValue("error-other", response.data.message);
          } else {
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error", responses);
          }
        });
      })
    },
    fetchEdit(){
      this.asyncAxiosGet("kartu_kredit/recon",
        this.getAuth,
        {id_rekon_cc_hdr: this.mode.id}
      )
      .then((response) => {
        let tempdata = response
        tempdata.dtl.forEach((element,index) => {
          element['no'] = index
          element['check'] = element.sts_rekon=='1' ? true : false
        });
        this.table.datasource = tempdata
        if(response.file) this.setUpFile(response.file_path, response.file_nm, response.file);
      })
    },
    changeChecked(item){
      let data = new FormData();
      data.append("id_rekon_cc_hdr", item.id_rekon_cc_hdr);
      data.append("id_rekon_cc_dtl", item.id_rekon_cc_dtl);

      this.table.loading = true
      this.asyncAxiosPost("kartu_kredit/recon_check", "formdata", this.getAuth, data)
      .then(() => {
        this.table.datasource.dtl[item.no].check = !item.check
        this.table.datasource.dtl.forEach((element,index) => {
          element['no'] = index
          element['check'] = element.sts_rekon=='1' ? true : false
        });

        this.displayMessageValue("success-other", (!item.check ? 'Check ' : 'Uncheck ')+' data success!');
        this.table.loading = false
      })
      .catch((err) => {
        let responses = Object.assign({}, err);
        if (responses.response.data) {
          this.displayMessageValue("error-other", responses.response.data.message);
        } else {
          this.displayMessageValue("error", responses.response);
        }
        this.table.loading = false
        this.table.datasource.dtl[item.no].check = item.check
      });
    },
    handleSubmit(){
    },
    setUpFile(path, file_name, files){
      var file = this.dataURLtoFile(
        this.fileTypeFromUrl(file_name) + files,
        file_name
      );
      file.uid = "vc-upload-1-1";
      file.status = "done";
      file.exist = true;
      file.url = this.$serviceUrl + path;
      this.evidance_billing_statement.fileList = [];
      this.evidance_billing_statement.fileList.push(file);
    }
  },
}
</script>

<style lang="less" scoped>
.wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  border: 1px solid darken(white, 10);
  &-header {
    height: 50px;
    background: darken(white, 2);
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-transform: capitalize;
    font-size: 1rem;
    font-weight: 500;
    color: @color-secondary;
    border-bottom: 1px dashed darken(white, 10);
    padding: @padding;
    &-child {
      height: 50px;
      background: none;
      display: flex;
      align-items: center;
      justify-content: space-between;
      text-transform: capitalize;
      font-size: 1rem;
      font-weight: 500;
      color: @color-secondary;
      border-bottom: 1px dashed darken(white, 10);
      padding-left: 0px;
    }
  }
  &-body {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
}

.bordered {
  border: 1px solid darken(white, 10);
}

.onlyviewlnk{
  .ant-upload-select{
    display: block;
  }
}
</style>
<style lang="less">
  .tablereconciledtl {
    .bg_red { 
      background-color: fade(@color-primary, 35%)!important;
    }
    .bg_none{
      background-color: none!important;
    }
  }
</style>